"use client";

import { site, trackContact, whatsappHref } from "../../lib/site";

export default function MobileContactBar() {
  return (
    <div className="fixed inset-x-0 bottom-0 z-40 grid grid-cols-3 border-t border-slate-200 bg-white lg:hidden">
      <a href={`tel:${site.phoneTel}`} onClick={() => trackContact("call")} className="px-2 py-3 text-center text-sm font-bold text-slate-900">Call</a>
      <a href={whatsappHref("Hello LITPL, I want to discuss a business requirement.")} target="_blank" rel="noopener noreferrer" onClick={() => trackContact("whatsapp")} className="border-x border-slate-200 px-2 py-3 text-center text-sm font-bold text-slate-900">WhatsApp</a>
      <a href="/contact#enquiry" onClick={() => trackContact("form")} className="bg-brand-700 px-2 py-3 text-center text-sm font-bold text-white">Enquire</a>
    </div>
  );
}
